import { CommonResponse, RackAckResponse, RackPositionResponseModel, RackResponseModel, RackZoneLevelRequest } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RackDTONew } from './dto/rack.dto';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { RackPositionService } from './rack-position.service';
import { RackPostionRequest } from './dto/rack-position.request';
import { RackIdRequest } from './dto/rack-id-request';
import { PlantRackPosRequest } from './dto/plant-rack-pos.request';
import { RackSuggestionRequest } from './dto/rack-suggestion-request';
import { LocationsRequest } from './dto/locations.request';
import { RackPositionIdRequest } from './dto/rack-position-id.request';
import { ZoneIdRequest } from './dto/zone-id.request';
import { SoIdRequest } from './dto/so-id.request';
import { ZoneRackIdRequest } from './dto/zone-rack-id.request';
import { RackReserveRequest } from '@gtpl/shared-models/warehouse-management';
import { RackStatusRequest } from './dto/rack-status.request';
import { RackPostionReq } from './dto/rack-position-request';
import { ReservedRacksSoRequest } from './dto/reserved-racks-so.request';
import { StockTransferDto } from './dto/update-rackposition.request';
import { ReserveRacksPostionsRequest } from './dto/reserve-racks-positions.request';
import { RackSuggestionRequestDto } from './dto/rack-suggestion.request.dto';
import { RackPositionId } from '../../../../../../libs/shared-models/masters/src/lib/racks';
import { InternalTransferDto } from './dto/internal-transfer-dto';

@ApiTags('rack-position')
@Controller('rack-position')
export class RackPositionController {
    constructor(
        private rackService: RackPositionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) {}

    /**
     * calling a service to create a new rack
     * @param rackDto 
     * @returns 
    */
     @Post('/createRackPosition')
     async createRackPosition(@Body() rackDto: RackDTONew): Promise<RackAckResponse>  {
         try {
             return await this.rackService.createRackPosition(rackDto);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RackAckResponse, error);
         }
     }
  
     /**
      * callling a service to update a existing rack
      * @param rackDto 
      * @returns 
      */
     @Post('/updateRackPosition')
     async updateRackPosition(@Body() rackDto: RackDTONew): Promise<RackAckResponse>  {
         try {
             return await this.rackService.updateRackPosition(rackDto);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RackAckResponse, error);
         }
     }
  
     /**
      * calling a service to get all racks
      * @returns 
      */
     @Post('getAllRacksPositions')
     async getAllRacksPositions():Promise<RackAckResponse> {
         try {
             return await this.rackService.getAllRacksPositions();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(RackAckResponse, error);
         }
     }
 
     /**
      * calling a service to get all racks by plant id
      * @param plantIdReq
      * @returns 
      */
      @Post('getAllRacksByPlantId')
      async getAllRacksByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<RackAckResponse> {
          try {
              return await this.rackService.getAllRacksByPlantId(plantIdReq);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackAckResponse, error);
          }
      }

    /**
     * Activate Or De-Activate Value Rack
     * @param getSingleRack RackResponseModel 
     * @returns Value Rack
     */
    @Post('/activateOrDeactivateRack')
    async activateOrDeactivateRack(@Body() rackReq: RackPostionRequest): Promise<RackAckResponse> {
        try {
            return await this.rackService.activateOrDeactivateRack(rackReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RackAckResponse, err);
        }
    }

    @Post('getRacksForRackId')
      async getRacksForRackId(@Body() rackPostionRequest: RackIdRequest):Promise<RackPositionResponseModel> {
          try {
              return await this.rackService.getRacksForRackId(rackPostionRequest);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
          }
      }

      @Post('getRacksForZoneId')
      async getRacksForZoneId(@Body() rackPostionRequest: ZoneIdRequest):Promise<RackPositionResponseModel> {
          try {
              return await this.rackService.getRacksForZoneId(rackPostionRequest);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
          }
      }

      @Post('getAvailableRackPositionsForZoneId')
      async getAvailableRackPositionsForZoneId(@Body() rackPostionRequest: ZoneRackIdRequest): Promise<RackPositionResponseModel> {
          try {
              return await this.rackService.getAvailableRackPositionsForZoneId(rackPostionRequest);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
          }
      }

      @Post('getAvailableRackPositionsForPlantId')
      async getAvailableRackPositionsForPlantId(@Body() req: RackSuggestionRequest): Promise<RackPositionResponseModel> {
          try {
              return await this.rackService.getAvailableRackPositionsForPlantId(req);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
          }
      }
      @Post('getReservedRackPositionsForSO')
      async getReservedRackPositionsForSO(@Body() reservedRacksSoRequest: ReservedRacksSoRequest): Promise<RackPositionResponseModel> {
          try {
              return await this.rackService.getReservedRackPositionsForSO(reservedRacksSoRequest);
          } catch (error) {
              return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
          }
      }


    @Post('getRackPositionsForRackMasterId')
    async getRackPositionsForRackMasterId(@Body() rackPostionRequest: RackIdRequest):Promise<RackResponseModel> {
        try {
            return await this.rackService.getRackPositionsForRackMasterId(rackPostionRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackResponseModel, error);
        }
    }

    /**
     * calling a service to epc for rack position code
     * @param plantRackPosReq
     * @returns 
    */
     @Post('getEpcForRackPosition')
     async getEpcForRackPosition(@Body() plantRackPosReq: PlantRackPosRequest):Promise<CommonResponse> {
         try {
             return await this.rackService.getEpcForRackPosition(plantRackPosReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }
     @Post('updateRackPostionOccupancy')
     async updateRackPostionOccupancy(@Body() plantRackPosReq: RackIdRequest):Promise<CommonResponse> {
         try {
             return await this.rackService.updateRackPostionOccupancy(plantRackPosReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }
     @Post('updateRackPostionOccupancyNotOccupied')
     async updateRackPostionOccupancyNotOccupied(@Body() plantRackPosReq: RackIdRequest):Promise<CommonResponse> {
         try {
             return await this.rackService.updateRackPostionOccupancyNotOccupied(plantRackPosReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }

     @Post('freeRackPostionOccupancy')
     async freeRackPostionOccupancy(@Body() plantRackPosReq: RackIdRequest):Promise<CommonResponse> {
         try {
             return await this.rackService.freeRackPostionOccupancy(plantRackPosReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }

     @Post('updateRackStatus')
     async updateRackStatus(@Body() plantRackPosReq: StockTransferDto):Promise<boolean> {
         try {
             return await this.rackService.updateRackStatus(plantRackPosReq);
         } catch (error) {
            //  return this.applicationExceptionHandler.returnException(Boolean, error);
         }
     }

     @Post('updateRackPositionStatus')
     async updateRackPositionStatus(@Body() plantRackPosReq: RackPositionId):Promise<boolean> {
         try {
             return await this.rackService.updateRackPositionStatus(plantRackPosReq);
         } catch (error) {
            //  return this.applicationExceptionHandler.returnException(Boolean, error);
         }
     }

     @Post('reserveRackPositions')
     async reserveRackPositions(@Body() rackSuggestionRequest: RackSuggestionRequest):Promise<any>{
         return await this.rackService.reserveRackPositions(rackSuggestionRequest);
     }
     @Post('getSuggestLocation')
    async getSuggestLocation(@Body() locationsRequest: LocationsRequest): Promise<CommonResponse> {
         return await this.rackService.getSuggestLocation(locationsRequest);
     }
     @Post('getReserveRackPosition')
    async getReserveRackPosition(@Body() rackPositionIdRequest: RackPositionIdRequest): Promise<CommonResponse> {
         return await this.rackService.getReserveRackPosition(rackPositionIdRequest);
     }

     @Post('getLocationByZRL')
     async getLocationByZRL(@Body() req: RackZoneLevelRequest){
          return await this.rackService.getLocationByZRL(req);
      }
    @Post('/getUnreserveRackPositions')
    async getUnreserveRackPositions(@Body() req:SoIdRequest): Promise<CommonResponse> {
        try {
        return await this.rackService.getUnreserveRackPositions(req);
        } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getRackStatus')
    async getRackStatus(@Body() req:RackStatusRequest): Promise<CommonResponse> {
        try {
        return await this.rackService.getRackStatus(req);
        } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/reserveRackPosition')
    async reserveRackPosition(@Body() rackSuggestionRequest: RackSuggestionRequest):Promise<CommonResponse>{
        try {
        return await this.rackService.reserveRackPosition(rackSuggestionRequest);
        } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getUnit1RackPositions')
    async getUnit1RackPositions(@Body() plantIdRequest: PlantIdRequest):Promise<any>{
        try {
        return await this.rackService.getUnit1RackPositions(plantIdRequest);
        } catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('updateOccupancyAfterTransfer')
    async updateOccupancyAfterTransfer(@Body() req: RackPostionReq):Promise<CommonResponse> {
        try {
            return await this.rackService.updateOccupancyAfterTransfer(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('reserveRacksForIssuedQty')
    async reserveRacksForIssuedQty(@Body() req: ReserveRacksPostionsRequest):Promise<CommonResponse>{
        try {
            return await this.rackService.reserveRacksForIssuedQty(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('getNotOccupiedLocationsForPlant')
    async getNotOccupiedLocationsForPlant(@Body() req: PlantIdRequest):Promise<CommonResponse> {
        try {
            return await this.rackService.getNotOccupiedLocationsForPlant(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getRackSuggestion')
    async getRackSuggestion(@Body() req: RackSuggestionRequestDto):Promise<CommonResponse>{
        try {
            return await this.rackService.getRackSuggestion(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getRackDetailsById')
    async getRackDetailsById(@Body() req: RackPositionId):Promise<CommonResponse>{
        try {
            return await this.rackService.getRackDetailsById(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getAvailableRackPositionsForInternalTransfer')
    async getAvailableRackPositionsForInternalTransfer(@Body() req: InternalTransferDto):Promise<RackPositionResponseModel>{
        try {
            return await this.rackService.getAvailableRackPositionsForInternalTransfer(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackPositionResponseModel, error);
        }
    }
}
